import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "header" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Segment = _resolveComponent("Segment")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _directive_resize = _resolveDirective("resize")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString($data.expanded ? 'Collapse to view less' : 'Scroll or expand to view more'), 1 /* TEXT */),
      _createCommentVNode(" <Icon :icon=\"expanded ? 'chevron-up-double' : 'chevron-down-double'\" \n          width=\"2rem\" height=\"2rem\" \n          class=\"icon pointer\" \n          @click=\"expanded=!expanded\"\n    /> "),
      _withDirectives(_createVNode(_component_Icon, {
        icon: "chevron-up-double",
        width: "2rem",
        height: "2rem",
        class: "icon pointer",
        onClick: _cache[0] || (_cache[0] = $event => ($data.expanded=!$data.expanded))
      }, null, 512 /* NEED_PATCH */), [
        [_vShow, $data.expanded]
      ]),
      _withDirectives(_createVNode(_component_Icon, {
        icon: "chevron-down-double",
        width: "2rem",
        height: "2rem",
        class: "icon pointer",
        onClick: _cache[1] || (_cache[1] = $event => ($data.expanded=!$data.expanded))
      }, null, 512 /* NEED_PATCH */), [
        [_vShow, !$data.expanded]
      ])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_ScrollBar, {
      style: _normalizeStyle({height: $options.c_max_height}),
      class: "segments"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, (item) => {
          return (_openBlock(), _createBlock(_component_Segment, {
            key: item.value,
            ref_for: true,
            ref: "segments",
            class: _normalizeClass({active: _ctx.value.includes(item.value)})
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Checkbox, {
                "model-value": _ctx.value.includes(item.value),
                "font-size": "1.4rem",
                "checked-value": item.value,
                onChange: $options.onChange
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.label), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["model-value", "checked-value", "onChange"])
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["style"])), [
      [_directive_resize, $options.onResize]
    ])
  ], 64 /* STABLE_FRAGMENT */))
}